<form
	#categoryForm="ngForm"
	[formGroup]="formGroup"
	(ngSubmit)="saveChanges()">
	<div class="card-feature">
		<button ejs-button iconCss="fa fa-chevron-left" (click)="returnToList(false)">
			All {{ categoryTitle }}
		</button>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col-md-12 col-xl-6">
				@if (formGroup.invalid && categoryForm.submitted) {
					<gandalf-lib-validation-messages
						[form]="formGroup"
						[requestObj]="createOrUpdateRequest">
					</gandalf-lib-validation-messages>
				}
				<div class="row mb-3">
					<label class="col-md-4 col-lg-3 col-form-label required">Name</label>
					<div class="col-md-8 col-lg-9">
						<input type="text" class="e-input" revFocusInput formControlName="name"/>
					</div>
				</div>
				<div class="row mb-3">
					<label class="col-md-4 col-lg-3 col-form-label">Description</label>
					<div class="col-md-8 col-lg-9">
						<input type="text" class="e-input"
							   formControlName="description"/>
					</div>
				</div>
				<div class="row mb-3">
					<div class="col-md-8 col-lg-9 offset-sm-4 offset-md-3">
						<ejs-checkbox formControlName="active" label="Active"></ejs-checkbox>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="card-footer">
		<button ejs-button type="submit" [isPrimary]="true">Save</button>
		<button ejs-button type="button" iconCss="fa fa-close" (click)="returnToList(false)">Cancel</button>
	</div>
</form>
